const code200Error = {
  1001: ["请求参数无效", "PARAM_INVALID"],
  1002: ["缺少必填参数", "PARAM_MISSING"],
  1003: ["数据不存在", "DATA_NOT_EXIST"],
  1004: ["数据重复", "DATA_DUPLICATE"],
  1005: ["操作不允许", "OPERATION_NOT_ALLOWED"],
  1006: ["请求过于频繁,请稍后重试!", "FREQUENT_REQUEST"],
  1007: ["系统繁忙，请稍后重试!", "SYSTEM_BUSY"],
  1008: ["远程服务调用失败", "REMOTE_CALL_FAIL"],
  1009: ["第三方服务异常", "THIRD_PARTY_ERROR"],
  1010: ["获取汇率异常", "GET_EXCHANGE_RATE_ERROR"],
  1100: ["文件上传失败", "FILE_UPLOAD_FAIL"],
  1101: ["文件下载失败", "FILE_DOWNLOAD_FAIL"],
  1102: ["文件格式不正确", "FILE_FORMAT_ERROR"],
  1103: ["文件大小超出限制", "FILE_SIZE_EXCEED"],
  1104: ["文件Key不能为空", "FILE_KEY_REQUIRED"],
  1105: ["文件桶未配置", "FILE_BUCKET_NOT_CONFIGURED"],
  1106: ["上传文件内容不能为空", "FILE_UPLOAD_CONTENT_EMPTY"],
  1107: ["附件来源文件不存在", "ATTACHMENT_SOURCE_FILE_NOT_FOUND"],
  1108: ["附件来源文件无权使用", "ATTACHMENT_SOURCE_FILE_ACCESS_DENIED"],
  1109: ["附件查询范围无效", "ATTACHMENT_QUERY_SCOPE_INVALID"],
  1110: ["下载附件不存在", "FILE_ATTACHMENT_NOT_FOUND"],
  1111: ["文件中心记录不存在", "FILE_CENTER_RECORD_NOT_FOUND"],
  1112: ["附件查询登录主体不存在", "ATTACHMENT_LOGIN_CONTEXT_NOT_FOUND"],
  1113: ["附件查询参数不合法", "ATTACHMENT_QUERY_PARAM_INVALID"],
  1114: ["附件不存在", "ATTACHMENT_NOT_FOUND"],
  1115: ["附件无权访问", "ATTACHMENT_ACCESS_DENIED"],
  1116: ["文件删除失败", "FILE_DELETE_FAIL"],
  1201: ["课程不存在", "COURSE_NOT_FOUND"],
  1202: ["学校不存在", "SCHOOL_NOT_FOUND"],
  1203: ["专业大类不存在", "MAJOR_CATEGORY_NOT_FOUND"],
  1204: ["课程分组不存在", "COURSE_GROUP_NOT_FOUND"],
  1205: ["课程分组与课程所属学校不一致", "COURSE_GROUP_SCHOOL_MISMATCH"],
  1206: ["背景学校不存在", "BG_SCHOOL_NOT_FOUND"],
  1207: ["专业大类名称已存在", "MAJOR_CATEGORY_NAME_DUPLICATED"],
  1301: ["申请人主体不存在", "APPLY_USER_NOT_FOUND"],
  1302: ["学生档案不存在", "STUDENT_INFO_NOT_FOUND"],
  1303: ["申请人主体已被业务数据引用，不允许删除", "APPLY_USER_REFERENCED"],
  1304: ["学生档案已被业务数据引用，不允许删除", "STUDENT_INFO_REFERENCED"],
  1305: ["当前学生档案不允许删除", "STUDENT_INFO_CURRENT_DELETE_NOT_ALLOWED"],
  1306: ["多学生档案场景必须指定学生档案ID", "STUDENT_INFO_DELETE_ID_REQUIRED"],
  1307: ["学生档案申请类型无效", "STUDENT_INFO_APPLY_TYPE_INVALID"],
  1308: ["学生档案无权访问", "STUDENT_INFO_ACCESS_DENIED"],
  1309: [
    "学生教育经历学校类型不存在",
    "STUDENT_INFO_INSTITUTION_TYPE_NOT_FOUND",
  ],
  1401: ["对话不存在", "CHAT_NOT_FOUND"],
  1402: ["对话记录不存在", "CHAT_RECORD_NOT_FOUND"],
  1403: ["附件不存在", "CHAT_FILE_NOT_FOUND"],
  1404: ["无权访问当前数据", "ACCESS_DENIED"],
  1405: ["对话编排服务未配置", "CHAT_ORCHESTRATOR_NOT_CONFIGURED"],
  1406: ["对话编排服务调用失败", "CHAT_ORCHESTRATOR_CALL_FAIL"],
  1407: ["对话编排服务响应为空", "CHAT_ORCHESTRATOR_RESPONSE_EMPTY"],
  1408: ["对话反馈状态无效", "CHAT_FEEDBACK_STATUS_INVALID"],
  1409: ["当前对话记录不可反馈", "CHAT_RECORD_NOT_FEEDBACKABLE"],
  1410: ["附件查询标识不能为空", "CHAT_FILE_QUERY_KEY_REQUIRED"],
  1411: ["我的文件目标学生档案不存在", "CHAT_MY_FILE_TARGET_STUDENT_NOT_FOUND"],
  1412: ["生成文件类型不能为空", "CHAT_GENERATED_FILE_TYPE_REQUIRED"],
  1413: ["生成文件名称不能为空", "CHAT_GENERATED_FILE_NAME_REQUIRED"],
  1414: ["生成文件构建失败", "CHAT_GENERATED_FILE_BUILD_FAIL"],
  1415: ["生成文件内容获取失败", "CHAT_GENERATED_CONTENT_FAIL"],
  1416: ["聊天文件保存动作无效", "CHAT_FILE_SAVE_ACTION_INVALID"],
  1417: ["聊天文件保存目标类型无效", "CHAT_FILE_SAVE_TYPE_INVALID"],
  1418: ["生成文件内容为空", "CHAT_GENERATED_CONTENT_EMPTY"],
  1419: ["对话类型无效", "CHAT_TYPE_INVALID"],
  1420: ["对话类型与当前会话不一致", "CHAT_TYPE_NOT_MATCH"],
  1421: ["对话编排接口路径未配置", "CHAT_ORCHESTRATOR_PATH_NOT_CONFIGURED"],
  1422: ["生成文件内容格式不正确", "CHAT_GENERATED_CONTENT_FORMAT_INVALID"],
  1423: ["生成文件内容接口未配置", "CHAT_GENERATED_CONTENT_NOT_CONFIGURED"],
  1424: ["PDF生成接口未配置", "CHAT_GENERATE_PDF_NOT_CONFIGURED"],
  1425: ["PDF生成失败", "CHAT_GENERATE_PDF_FAIL"],
  1426: ["PDF生成结果为空", "CHAT_GENERATE_PDF_CONTENT_EMPTY"],
  1501: ["择校匹配规则配置无效", "SELECT_SCHOOL_MATCH_RULE_CONFIG_INVALID"],
  1502: ["择校匹配查询条件不能为空", "SELECT_SCHOOL_MATCH_QUERY_REQUIRED"],
  1503: ["择校匹配必填条件缺失", "SELECT_SCHOOL_MATCH_QUERY_FIELD_REQUIRED"],
  1504: ["择校匹配语言类型无效", "SELECT_SCHOOL_MATCH_LANGUAGE_TYPE_INVALID"],
  1505: ["择校查询快照不存在", "SELECT_SCHOOL_QUERY_SNAPSHOT_NOT_FOUND"],
  1506: ["择校查询快照无权访问", "SELECT_SCHOOL_QUERY_SNAPSHOT_ACCESS_DENIED"],
  1601: ["择校方案名称不能为空", "SELECT_SCHOOL_PLAN_NAME_REQUIRED"],
  1602: ["更新择校方案必须指定方案ID", "SELECT_SCHOOL_PLAN_UPDATE_ID_REQUIRED"],
  1603: ["择校方案不存在", "SELECT_SCHOOL_PLAN_NOT_FOUND"],
  1604: ["择校方案名称已存在", "SELECT_SCHOOL_PLAN_NAME_DUPLICATED"],
  1605: [
    "默认择校方案不能取消默认",
    "SELECT_SCHOOL_PLAN_DEFAULT_CANCEL_NOT_ALLOWED",
  ],
  1606: [
    "默认择校方案不允许删除",
    "SELECT_SCHOOL_PLAN_DEFAULT_DELETE_NOT_ALLOWED",
  ],
  1607: ["择校方案课程必填条件缺失", "SELECT_SCHOOL_PLAN_ITEM_FIELD_REQUIRED"],
  1608: ["择校方案课程不存在", "SELECT_SCHOOL_PLAN_ITEM_NOT_FOUND"],
  1609: ["择校方案匹配档位无效", "SELECT_SCHOOL_PLAN_MATCH_LEVEL_INVALID"],
  1610: ["同一方案内课程不能重复", "SELECT_SCHOOL_PLAN_ITEM_COURSE_DUPLICATED"],
  1611: [
    "默认择校方案不存在，请先创建方案",
    "SELECT_SCHOOL_PLAN_DEFAULT_NOT_FOUND",
  ],
  1612: [
    "择校方案没有可更新内容",
    "SELECT_SCHOOL_PLAN_UPDATE_CONTENT_REQUIRED",
  ],
  1701: [
    "正式申请初始化参数不能为空",
    "SELECT_SCHOOL_APPLY_INIT_PARAM_REQUIRED",
  ],
  1702: ["正式申请不存在", "SELECT_SCHOOL_APPLY_NOT_FOUND"],
  1703: ["正式申请无权访问", "SELECT_SCHOOL_APPLY_ACCESS_DENIED"],
  1704: ["当前申请状态不允许提交", "SELECT_SCHOOL_APPLY_SUBMIT_STATUS_INVALID"],
  1705: ["当前申请状态不允许删除", "SELECT_SCHOOL_APPLY_DELETE_STATUS_INVALID"],
  1706: [
    "当前申请状态不允许同步AIS",
    "SELECT_SCHOOL_APPLY_SYNC_STATUS_INVALID",
  ],
  1707: ["当前申请状态不允许编辑", "SELECT_SCHOOL_APPLY_EDIT_STATUS_INVALID"],
  1708: [
    "多学生档案场景必须指定学生档案ID",
    "SELECT_SCHOOL_APPLY_STUDENT_INFO_REQUIRED",
  ],
  1709: ["正式申请课程不能为空", "SELECT_SCHOOL_APPLY_COURSE_REQUIRED"],
  1710: [
    "正式申请课程必填条件缺失",
    "SELECT_SCHOOL_APPLY_COURSE_FIELD_REQUIRED",
  ],
  1711: [
    "正式申请学生档案快照不存在",
    "SELECT_SCHOOL_APPLY_PROFILE_SNAPSHOT_NOT_FOUND",
  ],
  1712: [
    "正式申请课程快照不存在",
    "SELECT_SCHOOL_APPLY_COURSE_SNAPSHOT_NOT_FOUND",
  ],
  1713: [
    "正式申请必传附件缺失",
    "SELECT_SCHOOL_APPLY_REQUIRED_ATTACHMENT_MISSING",
  ],
  1714: [
    "AIS同步默认代理编号未配置",
    "SELECT_SCHOOL_APPLY_AIS_AGENT_CONFIG_MISSING",
  ],
  1715: ["AIS同步默认代理不存在", "SELECT_SCHOOL_APPLY_AIS_AGENT_NOT_FOUND"],
  1716: [
    "AIS同步默认代理未绑定有效公司",
    "SELECT_SCHOOL_APPLY_AIS_COMPANY_NOT_FOUND",
  ],
  1717: [
    "AIS同步平台编码未配置",
    "SELECT_SCHOOL_APPLY_AIS_PLATFORM_CONFIG_MISSING",
  ],
  1718: ["AIS同步平台不存在", "SELECT_SCHOOL_APPLY_AIS_PLATFORM_NOT_FOUND"],
  1719: [
    "当前申请已同步AIS，正在审核中",
    "SELECT_SCHOOL_APPLY_AIS_SYNC_IN_PROGRESS",
  ],
  1720: [
    "当前申请已审核通过，不允许再次同步",
    "SELECT_SCHOOL_APPLY_AIS_SYNC_APPROVED",
  ],
  1721: ["同步AIS学生审核失败", "SELECT_SCHOOL_APPLY_AIS_SYNC_FAILED"],
  1722: [
    "AIS同步申请人信息未完善",
    "SELECT_SCHOOL_APPLY_AIS_PROFILE_FIELD_REQUIRED",
  ],
  1723: [
    "AIS同步学历信息未完善",
    "SELECT_SCHOOL_APPLY_AIS_EDUCATION_FIELD_REQUIRED",
  ],
  1724: [
    "AIS同步学历字典映射不存在",
    "SELECT_SCHOOL_APPLY_AIS_EDUCATION_LEVEL_MAPPING_MISSING",
  ],
  1725: [
    "AIS同步申请课程信息未完善",
    "SELECT_SCHOOL_APPLY_AIS_COURSE_FIELD_REQUIRED",
  ],
  1726: [
    "AIS同步学校映射不存在",
    "SELECT_SCHOOL_APPLY_AIS_SCHOOL_MAPPING_MISSING",
  ],
  1727: [
    "正式申请学生档案快照不能为空",
    "SELECT_SCHOOL_APPLY_STUDENT_INFO_SNAPSHOT_REQUIRED",
  ],
  1728: ["当前学生档案已存在该课程申请", "SELECT_SCHOOL_APPLY_DUPLICATED"],
  1729: ["申请课程与原申请记录不匹配", "SELECT_SCHOOL_APPLY_COURSE_NOT_MATCH"],
};

export default code200Error;